<template>
    <div>
        <b-modal
            centered
            no-close-on-backdrop
            no-close-on-esc
            hide-header
            hide-footer
            v-model="modal.show"
            @hidden="closeModalConfirm()"
        >
            <card shadow type="secondary" class="m--4">
                <div class="header d-flex">
                    <div class="flex-grow-1 text-center">
                        <h2 class="font-weight-bold">อัพโหลด{{ modal.item.title }}</h2>
                        <span>เลือก{{ modal.item.title }}ที่ต้องการเพิ่มในรายการ</span>
                    </div>
                    <span class="close cursor-pointer" @click="closeModalConfirm()">&times;</span>
                </div>
                <b-card-body>
                    <b-form-group :label="`ไฟล์${modal.item.title}`">
                        <b-form-file
                            class="m-2"
                            v-model="form[modal.item.type]"
                            placeholder="Choose a file..."
                            drop-placeholder="Drop file here..."
                            accept=".pdf,.jpg,.jpeg"
                        >
                        </b-form-file>
                    </b-form-group>
                </b-card-body>
                <template slot="footer">
                    <b-row>
                        <b-col cols="4">
                            <b-button
                                block
                                @click="closeModalConfirm()"
                            >
                                ยกเลิก
                            </b-button>
                        </b-col>
                        <b-col cols="8">
                            <b-button 
                                type="submit" 
                                variant="primary" 
                                @click="$emit('confirmModal', modal.item.type )"
                                block
                                :disabled="modal.isLoad"
                            >
                                <i class="fas fa-circle-notch fa-spin" v-if="modal.isLoad"></i> 
                                อัพโหลด
                            </b-button>
                        </b-col>
                    </b-row>
                </template>
            </card>
        </b-modal>
    </div>
</template>

<script>
export default {
    props: {
        modal: {
            type: Object
        },
        form: {
            type: Object
        }
    },
    methods:{
        closeModalConfirm(){
            this.modal.show = false
            this.modal.isLoad = false
            this.modal.item = {
                type: null,
                title: ''
            }
        },
    }
}
</script>